/**
 * Routes whose URL is itself a credential and must therefore never be handed
 * to a third-party analytics endpoint.
 *
 * /degerlendir/:token carries a 90-day review invite token: whoever holds it
 * can write or delete that customer's reviews. Both gtag and the Meta Pixel
 * attach the current document URL to every hit they send, so any page_view
 * fired while such a URL is in the address bar leaks a working credential to
 * Google and Meta.
 *
 * The token deliberately stays in the address bar - reloading the invite link
 * has to keep prefilling the form - so the suppression happens at the two
 * places analytics is triggered instead: the initialization in
 * public/index.html (cold load, which is how the emailed link is always
 * opened) and Analytics.trackPageView (client-side navigation).
 *
 * NOTE: public/index.html carries an inline copy of this pattern, because it
 * has to run before this bundle is parsed. Keep the two in sync.
 */
export const SUPPRESSED_ANALYTICS_PATH = /^\/degerlendir(\/|$)/;

export function isAnalyticsSuppressedPath(pathname) {
  return SUPPRESSED_ANALYTICS_PATH.test(String(pathname == null ? '' : pathname));
}

export default isAnalyticsSuppressedPath;
